// Python code examples with both OpenAI SDK and requests implementations
const pythonExamples = {
  openai: {
    default: `import openai

openai.api_key = "YOUR_NEXTAPI_KEY"
openai.base_url = "https://api.nextapi.org/v1"

completion = openai.ChatCompletion.create(
    model="gpt-4o",
    messages=[
        {"role": "user", "content": "Hello!"}
    ]
)

print(completion.choices[0].message["content"])`,

    streaming: `import openai

openai.api_key = "YOUR_NEXTAPI_KEY"
openai.base_url = "https://api.nextapi.org/v1"

# Enable streaming
response = openai.ChatCompletion.create(
    model="gpt-4o",
    messages=[
        {"role": "system", "content": "You are a helpful assistant."},
        {"role": "user", "content": "Hello!"}
    ],
    stream=True
)

for chunk in response:
    if "content" in chunk.choices[0].delta:
        print(chunk.choices[0].delta["content"], end="")`,

    image: `import openai

openai.api_key = "YOUR_NEXTAPI_KEY"
openai.base_url = "https://api.nextapi.org/v1"

response = client.chat.completions.create(
    model="gpt-4o",
    messages=[
        {
            "role": "user",
            "content": [
                {"type": "text", "text": "What's in this image?"},
                {
                    "type": "image_url",
                    "image_url": {
                        "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Gfp-wisconsin-madison-the-nature-boardwalk.jpg/2560px-Gfp-wisconsin-madison-the-nature-boardwalk.jpg",
                    }
                },
            ],
        }
    ],
    max_tokens=300,
)

print(response.choices[0])`,

    functions: `import openai

openai.api_key = "YOUR_NEXTAPI_KEY"
openai.base_url = "https://api.nextapi.org/v1"

functions = [
    {
        "name": "get_current_weather",
        "description": "Get current weather in a location",
        "parameters": {
            "type": "object",
            "properties": {
                "location": {"type": "string", "description": "City name"},
                "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}
            },
            "required": ["location"]
        }
    }
]

response = openai.ChatCompletion.create(
    model="gpt-4o",
    messages=[
        {"role": "user", "content": "What's the weather in Boston?"}
    ],
    functions=functions
)

print(response.choices[0].message)`,

    logprobs: `import openai

openai.api_key = "YOUR_NEXTAPI_KEY"
openai.base_url = "https://api.nextapi.org/v1"

response = openai.Completion.create(
    model="text-davinci-003",
    prompt="Hello world",
    max_tokens=5,
    logprobs=5
)

print(response.choices[0].logprobs)`
  },

  requests: {
    default: `import requests

api_key = "YOUR_NEXTAPI_KEY"
base_url = "https://api.nextapi.org/v1/chat/completions"

headers = {
    "Content-Type": "application/json",
    "Authorization": f"Bearer {api_key}"
}

data = {
    "model": "gpt-4o",
    "messages": [
        {"role": "user", "content": "Hello!"}
    ]
}

response = requests.post(
    base_url,
    headers=headers,
    json=data
)

print(response.json()["choices"][0]["message"]["content"])`,

    streaming: `import requests
import json

api_key = "YOUR_NEXTAPI_KEY"
base_url = "https://api.nextapi.org/v1/chat/completions"

headers = {
    "Content-Type": "application/json",
    "Authorization": f"Bearer {api_key}"
}

data = {
    "model": "gpt-4o",
    "messages": [
        {"role": "system", "content": "You are a helpful assistant."},
        {"role": "user", "content": "Hello!"}
    ],
    "stream": True
}

response = requests.post(
    base_url,
    headers=headers,
    json=data,
    stream=True
)

for line in response.iter_lines():
    if line:
        json_str = line.decode("utf-8").replace("data: ", "")
        if json_str != "[DONE]":
            chunk = json.loads(json_str)
            if "content" in chunk["choices"][0]["delta"]:
                print(chunk["choices"][0]["delta"]["content"], end="")`,

    image: `import requests

api_key = "YOUR_NEXTAPI_KEY"
base_url = "https://api.nextapi.org/v1/chat/completions"

headers = {
    "Content-Type": "application/json",
    "Authorization": f"Bearer {api_key}"
}

json_data = {
    'model': 'gpt-4o',
    'messages': [
        {
            'role': 'user',
            'content': [
                {
                    'type': 'text',
                    'text': "What's in this image?",
                },
                {
                    'type': 'image_url',
                    'image_url': {
                        'url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Gfp-wisconsin-madison-the-nature-boardwalk.jpg/2560px-Gfp-wisconsin-madison-the-nature-boardwalk.jpg',
                    },
                },
            ],
        },
    ],
    'max_tokens': 300,
}

response = requests.post(
    base_url,
    headers=headers,
    json=json_data
)

image_url = response.json()["data"][0]["url"]
print("Generated image URL:", image_url)`,

    functions: `import requests

api_key = "YOUR_NEXTAPI_KEY"
base_url = "https://api.nextapi.org/v1/chat/completions"

headers = {
    "Content-Type": "application/json",
    "Authorization": f"Bearer {api_key}"
}

data = {
    "model": "gpt-4o",
    "messages": [
        {"role": "user", "content": "What's the weather in Boston?"}
    ],
    "functions": [
        {
            "name": "get_current_weather",
            "description": "Get current weather in a location",
            "parameters": {
                "type": "object",
                "properties": {
                    "location": {"type": "string", "description": "City name"},
                    "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}
                },
                "required": ["location"]
            }
        }
    ]
}

response = requests.post(
    base_url,
    headers=headers,
    json=data
)

print(response.json()["choices"][0]["message"])`,

    logprobs: `import requests

api_key = "YOUR_NEXTAPI_KEY"
base_url = "https://api.nextapi.org/v1/completions"

headers = {
    "Content-Type": "application/json",
    "Authorization": f"Bearer {api_key}"
}

data = {
    "model": "text-davinci-003",
    "prompt": "Hello world",
    "max_tokens": 5,
    "logprobs": 5
}

response = requests.post(
    base_url,
    headers=headers,
    json=data
)

print(response.json()["choices"][0]["logprobs"])`
  }
};

// Export examples with both Python implementations
export const defaultExample = {
  python: pythonExamples.openai.default,
  python_requests: pythonExamples.requests.default,
  javascript: `import OpenAI from "openai";

 
apiKey = 'YOUR_NEXTAPI_KEY' 
baseURL = 'https://api.nextapi.org/v1'

const openai = new OpenAI({
  apiKey: apiKey,
  baseURL: baseURL
});

async function main() {
  const completion = await openai.chat.completions.create({
    model: "gpt-4o",
    messages: [
      { role: "user", content: "Hello!" }
    ]
  });

  console.log(completion.choices[0].message.content);
}

main();`,
  curl: `curl https://api.nextapi.org/v1/chat/completions \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $NEXT_API_KEY" \\
  -d '{
    "model": "gpt-4o",
    "messages": [
      {
        "role": "user",
        "content": "Hello!"
      }
    ]
  }'`
};

export const streamingExample = {
  python: pythonExamples.openai.streaming,
  python_requests: pythonExamples.requests.streaming,
  javascript: `import OpenAI from "openai";

apiKey = 'YOUR_NEXTAPI_KEY' 
baseURL = 'https://api.nextapi.org/v1'

const openai = new OpenAI({
  apiKey: apiKey,
  baseURL: baseURL
});

async function main() {
  const stream = await openai.chat.completions.create({
    model: "gpt-4o",
    messages: [
      { role: "system", content: "You are a helpful assistant." },
      { role: "user", content: "Hello!" }
    ],
    stream: true
  });

  for await (const chunk of stream) {
    if (chunk.choices[0]?.delta?.content) {
      process.stdout.write(chunk.choices[0].delta.content);
    }
  }
}

main();`,
  curl: `curl https://api.nextapi.org/v1/chat/completions \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $NEXT_API_KEY" \\
  --no-buffer \\
  -d '{
    "model": "gpt-4o",
    "stream": true,
    "messages": [
      {
        "role": "system",
        "content": "You are a helpful assistant."
      },
      {
        "role": "user",
        "content": "Hello!"
      }
    ]
  }'`
};

export const imageExample = {
  python: pythonExamples.openai.image,
  python_requests: pythonExamples.requests.image,
  javascript: `import OpenAI from "openai";

apiKey = 'YOUR_NEXTAPI_KEY' 
baseURL = 'https://api.nextapi.org/v1'

const openai = new OpenAI({
  apiKey: apiKey,
  baseURL: baseURL
});

async function main() {
  const response = await openai.chat.completions.create({
    model: "gpt-4o",
    messages: [
      {
        role: "user",
        content: [
          { type: "text", text: "What's in this image?" },
          {
            type: "image_url",
            image_url: {
              "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Gfp-wisconsin-madison-the-nature-boardwalk.jpg/2560px-Gfp-wisconsin-madison-the-nature-boardwalk.jpg",
            },
          }
        ],
      },
    ],
  });
  console.log(response.choices[0]);
}
main();`,
  curl: `curl https://api.nextapi.com/v1/chat/completions
  -H "Content-Type: application/json"
  -H "Authorization: Bearer $NEXT_API_KEY"
  -d '{
    "model": "gpt-4o",
    "messages": [
      {
        "role": "user",
        "content": [
          {
            "type": "text",
            "text": "What'\''s in this image?"
          },
          {
            "type": "image_url",
            "image_url": {
              "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Gfp-wisconsin-madison-the-nature-boardwalk.jpg/2560px-Gfp-wisconsin-madison-the-nature-boardwalk.jpg"
            }
          }
        ]
      }
    ],
    "max_tokens": 300
  }'

  `
};

export const functionsExample = {
  python: pythonExamples.openai.functions,
  python_requests: pythonExamples.requests.functions,
  javascript: `import OpenAI from "openai";

apiKey = 'YOUR_NEXTAPI_KEY' 
baseURL = 'https://api.nextapi.org/v1'

const openai = new OpenAI({
  apiKey: apiKey,
  baseURL: baseURL
});

async function main() {
  const functions = [
    {
      name: "get_current_weather",
      description: "Get current weather in a location",
      parameters: {
        type: "object",
        properties: {
          location: {
            type: "string",
            description: "City name"
          },
          unit: {
            type: "string",
            enum: ["celsius", "fahrenheit"]
          }
        },
        required: ["location"]
      }
    }
  ];

  const response = await openai.chat.completions.create({
    model: "gpt-4o",
    messages: [
      { role: "user", content: "What's the weather in Boston?" }
    ],
    functions
  });

  console.log(response.choices[0].message);
}

main();`,
  curl: `curl https://api.nextapi.org/v1/chat/completions \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $NEXT_API_KEY" \\
  -d '{
    "model": "gpt-4o",
    "messages": [
      {
        "role": "user",
        "content": "What'\''s the weather in Boston?"
      }
    ],
    "functions": [
      {
        "name": "get_current_weather",
        "description": "Get current weather in a location",
        "parameters": {
          "type": "object",
          "properties": {
            "location": {
              "type": "string",
              "description": "City name"
            },
            "unit": {
              "type": "string",
              "enum": ["celsius", "fahrenheit"]
            }
          },
          "required": ["location"]
        }
      }
    ]
  }'`
};

export const logprobsExample = {
  python: pythonExamples.openai.logprobs,
  python_requests: pythonExamples.requests.logprobs,
  javascript: `import OpenAI from "openai";

apiKey = 'YOUR_NEXTAPI_KEY' 
baseURL = 'https://api.nextapi.org/v1'

const openai = new OpenAI({
  apiKey: apiKey,
  baseURL: baseURL
});

async function main() {
  const response = await openai.completions.create({
    model: "text-davinci-003",
    prompt: "Hello world",
    max_tokens: 5,
    logprobs: 5
  });

  console.log(response.choices[0].logprobs);
}

main();`,
  curl: `curl https://api.nextapi.org/v1/completions \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $NEXT_API_KEY" \\
  -d '{
    "model": "text-davinci-003",
    "prompt": "Hello world",
    "max_tokens": 5,
    "logprobs": 5
  }'`
};